import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [statusMessage, setStatusMessage] = useState(""); // ✅ Added for success/error message

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

    setStatusMessage("Sending message..."); // Optional: show loading message

    emailjs
      .sendForm(
        "service_uyx8vep", // ✅ Your EmailJS Service ID
        "template_3hgr1fr", // ✅ Your Template ID
        e.target,
        "7icOU_PKL0yyimhhR" // ✅ Your Public Key
      )
      .then(
        (result) => {
          console.log("Message sent:", result.text);
          setStatusMessage("✅ Message sent successfully!"); // ✅ Show success message
          clearState();
          setTimeout(() => setStatusMessage(""), 4000); // Hide after 4 sec
        },
        (error) => {
          console.error("Error sending message:", error.text);
          setStatusMessage("❌ Failed to send message. Please try again later.");
        }
      );
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Let’s connect! Share your details below, and our team will reach out shortly to discuss how we can bring your project to life.
                </p>
              </div>

              {/* ✅ Status Message */}
              {statusMessage && (
                <div
                  className={`alert ${
                    statusMessage.includes("✅") ? "alert-success" : "alert-danger"
                  }`}
                  style={{ marginBottom: "20px", fontWeight: "bold" }}
                >
                  {statusMessage}
                </div>
              )}

              <form name="sentMessage" validate="true" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                        value={name}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                        value={email}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                    value={message}
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-custom btn-lg">
                  Send Message
                </button>
              </form>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address:
                </span>{" "}
                {props.data ? props.data.address : "Loading..."}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone:
                </span>{" "}
                {props.data ? props.data.phone : "Loading..."}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email:
                </span>{" "}
                {props.data ? props.data.email : "Loading..."}
              </p>
            </div>
          </div>

          {/* Social Links */}
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a
                      href={props.data ? props.data.linkedin : "/"}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href={props.data ? props.data.github : "/"}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-github"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href={props.data ? props.data.upwork : "/"}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-briefcase"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; {new Date().getFullYear()} <strong>Global Webs Solution</strong>. All rights reserved. 
            Designed & Developed by{" "}
            <a href="https://www.globalwebssolution.com/" target="_blank" rel="noreferrer">
              Global Webs Solution
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
};
